// Function to update the free shipping message and progress bar.
function updateFreeShippingMessage (cartDrawer = null) {
    // Check if cartDrawer is provided, if not, update the /cart page
    const freeShippingMessage = cartDrawer
        ? cartDrawer.querySelector('#free-shipping-message')
        : document.querySelector('#MainContent #free-shipping-message');

    const progressBar = cartDrawer
        ? cartDrawer.querySelector('#free-shipping-progress-bar')
        : document.querySelector('#MainContent #free-shipping-progress-bar');

    if (!freeShippingMessage || !progressBar) { return; }

    // Get the cart total from the Shopify cart object.
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            const totalPrice = cart.total_price / 100;
            const threshold = freeShippingThreshold || 50;

            // Calculate the progress as a percentage.
            const progress = Math.min((totalPrice / threshold) * 100, 100);

            // Update the progress bar width.
            progressBar.style.width = progress + '%';

            // Check if the cart qualifies for free delivery
            if (totalPrice >= threshold) {
                freeShippingMessage.innerHTML = `
          <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
          </svg> 
          <span>Congratulations, you qualify for free delivery!</span>`;
            } else {
                const remainingAmount = (threshold - totalPrice).toFixed(2); // Calculate how much is needed

                freeShippingMessage.innerHTML = `
          <svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
          </svg> 
          You're only £${remainingAmount} away from free next working day delivery (order before 2pm)`;
            }
        })
        .catch((error) => {
            console.error('Error fetching the cart data:', error);
        });
}

// Listen for cart drawer updates.
function listenForCartDrawerUpdate () {
    // Select the cart drawer.
    const cartDrawer = document.querySelector('cart-drawer.drawer');

    if (!cartDrawer) {
        return;
    }

    // Create a MutationObserver to watch for both class and content changes.
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // Check for class changes
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (cartDrawer.classList.contains('active')) {
                    // Update free shipping message if #free-shipping-message is present
                    if (cartDrawer.querySelector('#free-shipping-message')) {
                        updateFreeShippingMessage(cartDrawer);
                    }
                }
            }

            // Check for child content changes
            if (mutation.type === 'childList') {
                if (mutation.target && mutation.target.querySelector('#free-shipping-message')) {
                    updateFreeShippingMessage(cartDrawer);
                }
            }
        });
    });

    // Configure the observer to watch for class and child changes.
    observer.observe(cartDrawer, {
        attributes: true,
        childList: true,
        subtree: true,
    });
}

// Listen for quantity changes in the cart drawer or /cart page.
function observeCartQuantityChanges () {
    // Select the cart drawer
    const cartBlocks = document.querySelector('.cart-template');

    if (!cartBlocks) {
        return;
    }

    // Create a MutationObserver to watch for changes in the cart page footer block.
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            // Check for class changes
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (document.querySelector('#free-shipping-message')) {
                    updateFreeShippingMessage();
                }
            }

            // Check for child content changes
            if (mutation.type === 'childList') {
                if (mutation.target && mutation.target.querySelector('#free-shipping-message')) {
                    updateFreeShippingMessage();
                }
            }
        });
    });

    observer.observe(cartBlocks, {
        childList: true,
        subtree: true,
        attributes: true,
    });
}

// Initialize the update for both the cart page and cart drawer
function initializeFreeShippingUpdates () {
    // Update the free shipping message on the /cart page load.
    const freeShippingMessageElement = document.querySelector('#MainContent #free-shipping-message');

    // On page load, update the free shipping message if the element exists.
    if (freeShippingMessageElement) {
        updateFreeShippingMessage();
    }

    // Listen for updates on the cart drawer.
    listenForCartDrawerUpdate();

    // Observe changes in cart quantities.
    observeCartQuantityChanges();
}

// Ensure the event listener is active when the page loads.
document.addEventListener('DOMContentLoaded', function () {
    initializeFreeShippingUpdates();
});
